import { FC, PropsWithChildren } from "react";
import { NavGroupProps } from "./NavGroup.props";
import styles from "./NavGroup.module.scss";
import cn from "classnames";
import { DrawerNavCard } from "../DrawerNavCard";
import { DashboardNavCard } from "../DashboardNavCard";

import { NavColors } from "../NavColors";

/**
 * The navigation group component.
 */
/**
 * @deprecated
 */
export const NavGroup: FC<PropsWithChildren<NavGroupProps>> = (props: PropsWithChildren<NavGroupProps>) => {
  const { id, testId, children, title, groupType = "drawer", color = NavColors.turquoise } = props;

  const navGroupStyles = cn("nav-group", styles.navGroup, groupType);

  let cardGroup = <DrawerNavCard color={color}>{children}</DrawerNavCard>;

  if (groupType === "dashboard") {
    cardGroup = <DashboardNavCard>{children}</DashboardNavCard>;
  }
  return (
    <div id={id} className={navGroupStyles} data-testid={testId ? `test__${testId}-nav-group` : undefined}>
      <div className={styles.navGroupTitle}>{title}</div>
      {cardGroup}
    </div>
  );
};
